import axios from '@/utils/request';
// 获取车辆类型列表数据
export const getCarTypeList = (params) => {
    return axios.get('/system/car/getCarTypeList', {params})
}